import React, { useEffect } from 'react'

import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore from 'swiper'

import LazyLoad from 'react-lazy-load'

import 'swiper/css'
import 'swiper/css/navigation'

import './Slider.scss'

import { Autoplay ,Navigation } from 'swiper/modules'

import 'aos/dist/aos.css'
import Aos from 'aos'

export default function Slider() {
  useEffect(() => {
    Aos.init({ duration: 2500 })
  }, [])
  SwiperCore.use([Autoplay])

  return (
    <>
      <LazyLoad offset={300}>
      <Swiper 
        speed={1800}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }} navigation={true} modules={[Autoplay,Navigation]} className="mySwiper">
        <SwiperSlide>
          <div className='sliderOneAr'>
            <div className="wrapperAr">
              <div className="container">
                <p data-aos='fade-up'>
                  الأسلاك المجلفنة<br />
                  العميقة الساخنة
                </p>
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className='sliderTwoAr'>
            <div className="wrapperAr">
              <div className="container">
                <p>
                  تصدير منتجات<br />
                  الصلب العالمية
                </p>
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className='sliderThreeAr'>
            <div className="wrapperAr">
              <div className="container">
                <p>
                  بناء
                </p>
              </div>
            </div>
          </div>
        </SwiperSlide>
        {/* <SwiperSlide>
          <div className='sliderFourAr'>
            <div className="wrapperAr">
              <div className="container">
                <p>
                  النفايات إلى<br />
                  محطة الطاقة
                </p>
              </div>
            </div>
          </div>
        </SwiperSlide> */}
      </Swiper>
      </LazyLoad>
    </>
  )
}
